module.exports = __webpack_public_path__ + "static/media/developers_overview_1.846be4c7.png";